<template>
  <div class="product">
    <router-link
      :to="`/${encodeURIComponent(this.nome_product)}/${encodeURIComponent(
        product.codigoDeBarras
      )}`"
    >
      <div class="product-inner">
        <div class="image-prod">
            <img :src="product.url" class="image" />
        </div>
        <div class="product-detail">
          <h2>{{ product.nome }}</h2>
          <!-- <h2 v-if="product.nome.length < 13">{{ product.nome }}</h2> -->
          <!-- <h2 v-else>{{product.nome.substring(0, 21)+"..."}}</h2> -->
          <p class="produto-size">Tamanho: {{ product.tamanho }}</p>
          <div>
            <p id="oldvalue">
              R$
              {{ product.preco.preco_venda.toFixed(2).replace(".", ",") }}
            </p>
            <p v-if="product.preco.preco_desconto && product.preco.preco_desconto != product.preco.preco_venda">
              por R$ {{ product.preco.preco_desconto.toFixed(2).replace(".", ",") }}
            </p>
            <!-- <p v-else>R$ {{ a_vista_valor.toFixed(2).replace(".", ",") }}</p> -->
            <!-- <p id="oldvalue" v-if="product.qntParcelas != 1">
              ou R$ {{ product.preco.preco_venda.toFixed(2).replace(".", ",") }}
            </p> -->
            <p id="parcelas" v-if="product.qntParcelas != 1">
              ou {{ product.qntParcelas }}x de R$
              {{ valor_parcelas.toFixed(2).replace(".", ",") }}
            </p>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "product",
  props: ["product"],
  data() {
    return {
      nome_product: "",
      a_vista_valor: 0,
      valor_parcelas: 0,
    };
  },
  beforeMount() {
    if (!this.product.nome) {
      this.product = null;
    }

    //this.nome_product = this.product.nome.replace(" ", "-");
    this.nome_product = encodeURIComponent(this.product.nome);

    let preco = this.product.preco.preco_venda;
    preco = preco - (preco * 10) / 100;
    this.a_vista_valor = preco;

    this.valor_parcelas =
      this.product.preco.preco_venda / this.product.qntParcelas;
  },
  methods: {},
};
</script>

<style>
a {
  text-decoration: none;
  color: #000000;
}

.product {
  margin: 10px;
  width: 310px;
  min-height: 200px;
  border: 1px #000000;
}

.product .product-inner{
  text-transform: uppercase;
}

.product .product-inner .image-prod {
  object-fit: cover;
}

.product .product-inner .image-prod .image{
  height: 300px;
  object-fit: cover;
}

.product .product-inner .product-detail{
  font-family: "SF Pro Text","Myriad Set Pro",system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI","SF Pro Icons","Apple Legacy Icons","Helvetica Neue","Helvetica","Arial",sans-serif;
}

.product .product-inner h2{
  font-size: 16px;
}

.product .product-inner #parcelas{
  font-size: 12px;
}

@media screen and (max-width: 800px) {
  .product {
    width: 100%;
    border-bottom: 1px solid #e4e4e4;
  }

  /* .product-image-wrap {
    width: 120px;
    height: 120px;
  }

  .product-image-wrap .image {
    height: 120px;
    width: 120px;
    object-fit: contain;
  } */

  .product-inner {
    display: inline-flex;
    background-color: #ffffff;
    height: 220px;
    width: 100%;
  }
}
</style>
